import { LoginProvider } from './reducer/LoginProvider';
import { LoginPage } from './LoginPage';
import { Routes } from '@xolv-mybrightlink/common';
import { useAuthRedirect } from '../auth/useAuthRedirect';

export const Login = () => {
  useAuthRedirect('AUTHENTICATED', Routes.authenticated);
  return (
    <LoginProvider>
      <LoginPage />
    </LoginProvider>
  );
};
